export default __webpack_public_path__ + "static/media/icono-abstracto-horizontal.8c2cf396.svg";